import { render, staticRenderFns } from "./attribute-dictionary-list.vue?vue&type=template&id=36a6d798"
import script from "./attribute-dictionary-list.vue?vue&type=script&lang=js"
export * from "./attribute-dictionary-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports